import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { LogIn, Shield } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      
      // Save token
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminEmail', response.data.email);

      toast.success("Connexion réussie!", {
        description: `Bienvenue ${response.data.email}`
      });

      // Redirect to dashboard
      navigate('/admin/dashboard');

    } catch (error) {
      console.error('Erreur de connexion:', error);
      toast.error("Échec de la connexion", {
        description: error.response?.data?.detail || "Email ou mot de passe incorrect"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#050505] via-[#121212] to-[#1a1a1a] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#FF6B35] to-[#FF8555] rounded-2xl shadow-2xl mb-6">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Innova-Solution CRM
          </h1>
          <p className="text-gray-400">
            Connexion administrateur
          </p>
        </div>

        <Card className="shadow-2xl border-white/10 bg-[#1a1a1a]/80 backdrop-blur-md">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-white">Connexion</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="email" className="text-gray-300">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="mt-2 bg-black/50 border-white/10 text-white focus:border-[#FF6B35]"
                  placeholder="admin@innova-solution.ca"
                  autoComplete="email"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-gray-300">Mot de passe</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="mt-2 bg-black/50 border-white/10 text-white focus:border-[#FF6B35]"
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8555] hover:from-[#FF8555] hover:to-[#FFA575] text-white py-6 text-lg shadow-lg hover:shadow-[0_0_30px_rgba(255,107,53,0.4)] transition-all duration-300 group"
              >
                {isSubmitting ? 'Connexion en cours...' : 'Se connecter'}
                <LogIn className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </form>

            <div className="mt-6 text-center">
              <button
                onClick={() => navigate('/')}
                className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors"
              >
                ← Retour au site
              </button>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-gray-500 text-sm mt-6">
          Accès réservé aux administrateurs autorisés
        </p>
      </div>
    </div>
  );
};
